import styled from "styled-components";

export const StyledBaseButton = styled.div`
    background: none;
    border: 0;
    cursor: pointer;
    padding: 0;
    text-align: inherit;
    text-decoration: none;

    &:disabled {
        cursor: not-allowed;
    }
`;
